// extracted by mini-css-extract-plugin
export default {"modal":"AddHistoryModal_modal__1BopZ","previewText":"AddHistoryModal_previewText__wwJ3Z","previewRow":"AddHistoryModal_previewRow__HiRto"};